import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Banner.css";
import cover from "../../../images/bk-hossain-cover.png";
// AOS
import AOS from "aos";
import "aos/dist/aos.css";
const Banner = () => {
  return (
    <div className="banner-bg">
      <div className="image-overlay"></div>
      <Container>
        <Row className="banner-content">
          <Col md={6} sm={12}>
            <div className="banner-title">
              <h1>
                Bakhtiar <br /> Hossain
              </h1>

              <div className="buttons">
                <Link
                  to="/files/Bakhtiar_Hossain_Resume.pdf"
                  target="_blank"
                  download
                >
                  <button style={{ marginRight: "10px" }} className="bk-button">
                    Resume
                  </button>
                </Link>
                <Link to="/contact-me">
                  <button className="bk-button">Contact Me</button>
                </Link>
              </div>
            </div>
          </Col>
          <Col md={6} sm={12}>
            <img
              className="cover-photo"
              data-aos="flip-right"
              src={cover}
              alt=""
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
